(function () {
    'use strict';

    angular
        .module('app')
        .factory('HttpApiInterceptor', HttpApiInterceptor);

    HttpApiInterceptor.$inject = ['moment', 'config',];

    function HttpApiInterceptor(moment, config) {
        var service = {
            request: requestHandler,
            response: responseHandler,
        };

        return service;

        function requestHandler(request) {
            if (request.data && request.url && request.url.indexOf(config.get('apiEndpoint')) > -1) {
                localDatesToUtc(request.data);
            }

            return request;
        }

        function responseHandler(response) {
            if (response.data && response.config && response.config.url && response.config.url.indexOf(config.get('apiEndpoint')) > -1) {
                utcDatesToLocal(response.data);
            }

            return response;
        }

        /**
         * Searches the object for date strings and transforms them to the UTC timezone.
         *
         * @param {object} object The request data object.
         *
         * @return {void}
         */
        function utcDatesToLocal(object) {
            Object.keys(object).forEach(function (key) {
                if (Object.prototype.hasOwnProperty.call(object, key) && key.indexOf('$') === -1) {
                    if (object[key] !== null && typeof object[key] === 'object') {
                        utcDatesToLocal(object[key]);
                    } else {
                        if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(object[key])) {
                            var date = moment.utc(object[key]).local();

                            object[key] = date.format('YYYY-MM-DD HH:mm:ss');
                        }
                    }
                }
            });
        }

        /**
         * Searches the object for date strings and transforms them to the local timezone.
         *
         * @param {object} object The response data object.
         *
         * @return {void}
         */
        function localDatesToUtc(object) {
            Object.keys(object).forEach(function (key) {
                if (Object.prototype.hasOwnProperty.call(object, key)) {
                    if (object[key] !== null && typeof object[key] === 'object') {
                        localDatesToUtc(object[key]);
                    } else {
                        if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(object[key]) && !/^\d{4}-\d{2}-\d{2} 00:00:00$/.test(object[key])) {
                            var date = moment(object[key]).utc();

                            object[key] = date.format('YYYY-MM-DD HH:mm:ss');
                        }
                    }
                }
            });
        }
    }

})();